import { Navigate, useNavigate } from 'react-router';
import * as utils from '../store/user/utils';
import { endpoint } from '../pages';

interface IIsAdminUser {}

const isAdminUser = <T extends IIsAdminUser>(WrappedComponent: React.ComponentType<T>) => {
    return (_props: T) => {
        if (!utils.isAdminUser()) {
            return <Navigate to={endpoint.home} />;
        }
        return <WrappedComponent {..._props} />;
    };
};

export default isAdminUser;
